import { render, staticRenderFns } from "./SubmitPanel.vue?vue&type=template&id=7b202fac&scoped=true"
import script from "./SubmitPanel.vue?vue&type=script&lang=js"
export * from "./SubmitPanel.vue?vue&type=script&lang=js"
import style0 from "./SubmitPanel.vue?vue&type=style&index=0&id=7b202fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b202fac",
  null
  
)

export default component.exports